/* eslint-disable no-console */
import React from 'react';
import {AsyncButton, DatePicker, Select, Checkbox} from '@nike/ruxac';
import {connect} from 'react-redux';
import {partsTriggerEmailAPI} from '../APIs/dataHelper';
import {setBeginDatePartsFilter, setEndDatePartsFilter,setFormatVersionPartsFilter, setFullPartDump} from '../Actions/partsFilters';
import {checkForToken, login} from '../APIs/loginHelper';

export class PartFilters extends React.Component {

    render() {
        const submitFilters = () => {
            const jwt = checkForToken ();
            if (!jwt || !jwt.accessToken) {
                //redirect to SSO if no jwt present
                console.log("NO JWT");
                login ();
            }
            else {
                this.props.partsTriggerEmailAPI(this.props.partsFilters, jwt.accessToken, this.props.userInfo.userName);
            }
        };
        const beginDateTokenized = this.props.partsFilters.beginDate.split('-');
        const endDateTokenized = this.props.partsFilters.endDate.split('-');
        const maxDateTokenized = this.props.partsFiltersData.maxDate.split('-');
        return (
            <div className={`filter-container-outer`}>
                <div className={'row filter-container-inner'}>
                    <div className={`col-xs-2 margin-right`}>
                        <div className="label">PARTS
                        </div>
                    </div>
                    <div className={`col-xs-2 margin-right `}>
                        <DatePicker
                            className="filter-component"
                            autoOk={true}
                            label="*Begin Date"
                            placeholder="Please select the begin date"
                            maxDate={new Date(maxDateTokenized[0], maxDateTokenized[1] - 1, maxDateTokenized[2])}
                            value={new Date(beginDateTokenized[0], beginDateTokenized[1] - 1, beginDateTokenized[2])}
                            disabled={this.props.partsFilters.fullDump}
                            onChange={(value) => {
                                const valueString = (new Date(value).getFullYear() + '-' + (new Date(value).getMonth() + 1) + '-' + new Date(value).getDate());
                                this.props.setBeginDatePartsFilter(valueString);
                                const checkEndDate = new Date(endDateTokenized[0], endDateTokenized[1] -1, endDateTokenized[2]);
                                if(value >= checkEndDate)
                                    this.props.setEndDatePartsFilter(valueString);
                            }}
                        />
                    </div>
                    <div className={`col-xs-2 margin-right`}>
                        <DatePicker
                            className="filter-component"
                            autoOk={true}
                            label="*End Date"
                            placeholder="Please select the end date"
                            minDate={new Date(beginDateTokenized[0], beginDateTokenized[1] - 1, beginDateTokenized[2])}
                            maxDate={new Date(new Date(maxDateTokenized[0], maxDateTokenized[1] - 1, maxDateTokenized[2]))}
                            value={new Date(endDateTokenized[0], endDateTokenized[1] -1, endDateTokenized[2])}
                            disabled={this.props.partsFilters.fullDump}
                            onChange={(value) => {
                                const valueString = (new Date(value).getFullYear() + '-' + (new Date(value).getMonth() + 1) + '-' + new Date(value).getDate());//(moment(value).year() + '-' + (moment(value).month() + 1) + '-' + moment(value).date());
                                this.props.setEndDatePartsFilter(valueString);

                            }}
                        />
                    </div>
                    <div className={`col-xs-2`}>
                        <Select
                            label="FORMAT VERSION"
                            className="filter-component"
                            options={[
                                {value : 'V1.0', label : 'V1.0'}
                            ]}
                            placeholder="V1.0"
                            allowClear
                            disabled={this.props.partsFilters.fullDump}
                            value={this.props.partsFilters.version}
                            onChange={(value) => {
                                this.props.setFormatVersionPartsFilter(value);
                            }}
                        />
                    </div>
                    {this.props.partsFilters.version === 'V1.0' && <div className={`checkbox data-dump`}>
                        <Checkbox
                            label="FULL DATA DUMP"
                            onChange={()=>this.props.setFullPartDump(this.props.partsFilters.fullDump)}
                            value = {this.props.partsFilters.fullDump}
                        />
                    </div>}
                    <div className={`col-xs-2 submit-btn`}>

                        <AsyncButton
                            onClick={submitFilters}
                        >
                            Submit
                        </AsyncButton>
                    </div>
                </div>
                <div>
                </div>
            </div>


        );
    }
}
const mapStateToProps = (state) => {
    return {
        partsFilters     : state.partsFilters,
        partsFiltersData : state.partsFiltersData,
        userInfo         : state.userInfo
    };
};

const mapDispatchToProps = {
    partsTriggerEmailAPI,
    setBeginDatePartsFilter,
    setEndDatePartsFilter,
    setFormatVersionPartsFilter,
    setFullPartDump
};

export default connect(mapStateToProps, mapDispatchToProps)(PartFilters);



// WEBPACK FOOTER //
// ./src/Components/PartsFilters.js